<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useUsersApi } from '../api/list.hook'
import TableUsers from './TableUsers.vue'
import ModalDeleteUser from './modals/ModalDeleteUser.vue'

defineOptions({
  name: 'UsersListPage',
})

onMounted(() => {
  void useUsersApi()
})

// Timestamps arrive pre-shifted into the admin's view timezone, so a timezone change needs a
// refetch rather than a client-side re-format.
useOnTimezoneChange(() => {
  void useUsersApi()
})
</script>

<template>
  <TableUsers />
  <ModalDeleteUser />
</template>
